import Session from '@/handler/session'
import Profiles from '@/config/profiles'
import Helper from '@/handler/helper'

// Esta Ok
const isAutenticado = (to, from, next) => {
  if (Session.getSession().settings.status && Session.getSession().auth) {
    if(Session.getSession().auth) {
      if(Session.getSession().lastPage) {
        var lastPage = Session.getSession().lastPage.slice(2,-1)
        Session.removeSessionLastPage()
        next({ path: lastPage })
        return
      }
      else {
        // Si está offline y es vendedor, ir directo a pedidos mobile
        if (!navigator.onLine &&
            Session.getSession().auth.user.profile_id == Profiles.PERSONAL &&
            !Session.getSession().auth.user.rol_admin &&
            Helper.getSeller()) {
          next({ name: 'OrdersStaffMobileOrderCreate' })
          return
        }

        // Si está offline y es personal (no admin, no vendedor) con acceso al
        // mostrador, ir directo a facturar offline.
        if (!navigator.onLine &&
            Session.getSession().auth.user.profile_id == Profiles.PERSONAL &&
            !Session.getSession().auth.user.rol_admin &&
            !Helper.getSeller() &&
            Helper.hasAccessModule('/st/sales/salesCounter')) {
          next({ name: 'SalesStaffSalesCounter' })
          return
        }

        if(Session.getSession().auth.user.profile_id == Profiles.SUPERADMIN) {
          next({ name: 'SA_ModulesConfigurate' })
          return
        } else {
          if(Session.getSession().auth.user.profile_id == Profiles.PERSONAL &&
              Session.getSession().auth.user.rol_admin) {
            next({ name: 'A_StaffConfigurate' })
            return
          } else {
            if(Session.getSession().auth.user.profile_id == Profiles.PERSONAL) {
              next({ name: Session.isMySpaceModeEnabled() ? 'MySpaceStaff' : 'DashboardStaff' })
              return
            }

            if(Session.getSession().auth.user.profile_id == Profiles.CLIENTE) {
              next({ name: 'DashboardCustomer' })
              return
            }

            if(Session.getSession().auth.user.profile_id == Profiles.PROVEEDOR) {
              next({ name: 'DashboardSupplier' })
              return
            }
          }
        }
      }
    }
  } else {
    next({ name: 'Init' })
  }
}

// Esta Ok
const isNotAutenticado = (to, from, next) => {
  if (Session.getSession().settings.status && !Session.getSession().auth) {
    next()
  } else {
    isAutenticado(to, from, next)
  }
}

// Esta Ok
const isNotConfigurado = (to, from, next) => {
  if (!Session.getSession().settings.status) {
    next()
  } else {
    next({ name: 'Init' })
  }
}

// Esta OK
const isSuperadmin = (to, from, next) => {
  if(Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id);
    if (Session.getSession().auth && perfil_id == Profiles.SUPERADMIN) {
      next()
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

// Esta OK
const isAdmin = (to, from, next) => {
  if(Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id);
    if (Session.getSession().auth && perfil_id == Profiles.PERSONAL &&
        Session.getSession().auth.user.rol_admin) {
      next()
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

// Esta OK
const isPersonal = (to, from, next) => {
  if(Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id);
    if (Session.getSession().auth && perfil_id == Profiles.PERSONAL &&
    !Session.getSession().auth.user.rol_admin) {
      if (Helper.hasAccessModule(to.path)) {
        next()
      } else {
        next({ name: 'Error404' })
      }
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

// Esta OK
const isCliente = (to, from, next) => {
  if(Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id);
    if (Session.getSession().auth && perfil_id == Profiles.CLIENTE) {
      if (Helper.hasAccessModule(to.path)) {
        next()
      } else {
        next({ name: 'Error404' })
      }
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

// Esta OK
const isProveedor = (to, from, next) => {
  if(Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id);
    if (Session.getSession().auth && perfil_id == Profiles.PROVEEDOR) {
      if (Helper.hasAccessModule(to.path)) {
        next()
      } else {
        next({ name: 'Error404' })
      }
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

export default {
  IS_AUTENTICADO: isAutenticado, // Esta OK
  IS_NOT_AUTENTICADO: isNotAutenticado, // Esta OK
  IS_NOT_CONFIGURADO: isNotConfigurado, // Esta OK
  IS_SUPERADMIN: isSuperadmin, // Esta OK
  IS_ADMIN: isAdmin, // Esta OK
  IS_PERSONAL: isPersonal, // Esta OK
  IS_CLIENTE: isCliente, // Esta OK
  IS_PROVEEDOR: isProveedor, // Esta OK
}
